// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 10px 0;
  margin: 0;
  font-size: 16px;
  color: #555;
  margin-top: 0;
  margin-left: 1px;
}

.breadcrumb li {
  display: flex;
  align-items: center;
  margin-left: 1px;
}

/* Chevron separator */
.breadcrumb li + li::before {
  content: "›";
  margin: 0 10px;
  color: #999;
  font-size: 16px;
}

/* Links */
.breadcrumb a {
  transition: color 0.3s ease;
  color: #034EA2;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
}

.breadcrumb a:hover {
  color: #034EA2;
  text-decoration: underline;
}

/* Active item */
.breadcrumb .active {
  color: #000;
  font-weight: 600;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/toheader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".breadcrumb {\r\n  display: flex;\r\n  align-items: center;\r\n  list-style: none;\r\n  padding: 10px 0;\r\n  margin: 0;\r\n  font-size: 16px;\r\n  color: #555;\r\n  margin-top: 0;\r\n  margin-left: 1px;\r\n}\r\n\r\n.breadcrumb li {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 1px;\r\n}\r\n\r\n/* Chevron separator */\r\n.breadcrumb li + li::before {\r\n  content: \"›\";\r\n  margin: 0 10px;\r\n  color: #999;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Links */\r\n.breadcrumb a {\r\n  transition: color 0.3s ease;\r\n  color: #034EA2;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.breadcrumb a:hover {\r\n  color: #034EA2;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Active item */\r\n.breadcrumb .active {\r\n  color: #000;\r\n  font-weight: 600;\r\n  cursor: default;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
